import { Container } from '@pixi/display';

import { Shared } from '../App';

export class RecStatus extends Container
{
    private info: HTMLDivElement;
    private recording = false;

    constructor()
    {
        super();

        this.info = document.createElement('div');
        this.info.style.position = 'fixed';
        this.info.style.width = '300px';
        this.info.style.background = 'rgba(0, 0, 0, 0.7)';
        this.info.style.pointerEvents = 'none';
        this.info.style.color = '#EEEEEE';
        this.info.style.bottom = '0px';
        this.info.style.padding = '10px';
        this.info.style.fontFamily = 'Roboto,sans-serif';
        this.info.style.fontSize = '0.75em';

        Shared.game.hud.view.addChild(this);

        this.refresh();
        Shared.game.onPlay.connect(() => this.refresh());
    }

    public updateTransform(): void
    {
        super.updateTransform();
        this.resize(Shared.game.app.resize.width, Shared.game.app.resize.height);
        if (Shared.game.replay.recording !== this.recording)
        {
            this.recording = Shared.game.replay.recording;
            this.refresh();
        }
    }

    private resize(w: number, h: number): void
    {
        w -= 30;
        h -= 30;

        this.x = -w / 2;
        this.y = -h / 2;
    }

    private async refresh(): Promise<void>
    {
        if (!Shared.game.race.raceIndex) return;

        const ghosts = await Shared.game.app.api.fetchLevelReplayEntries(Shared.game.level.getLevelHash(), 99);

        const text = [
            `STATUS: ${Shared.game.replay.recording ? 'RECORDING...' : 'IDLE'}`,
            `RACE: ${Shared.game.race.getRaceName()}`,
            `RACE LEVEL: ${Shared.game.race.getCurrentRaceDifficulty()}`,
            `RACE GEAR TIER: ${Shared.game.race.getCurrentRaceGearTier()}`,
            `RACE GHOSTS AVAILABLE: ${ghosts.length}`,
            `RACE MAX GHOSTS: ${Shared.game.race.getCurrentRaceMaxOpponents()}`,
        ];

        this.info.innerHTML = text.join('<br/>');
        document.body.appendChild(this.info);
    }
}

